import React from 'react';

export default function MscName(props) {
  const { name } = props;
  //use to prevent add event listener multitple times

  // useEffect(async () => {
  //   console.log(error);
  // }, [error]);
  if (name && name !== '') return <div className="username">Hi, {name}</div>;
  else return null;
}
